import React, { Suspense, lazy, useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
// Páginas de contenido SEO (URLs reales, prerenderizadas e hidratadas con
// hydrateRoot). NO son lazy a propósito: un boundary de <Suspense> + chunk lazy
// rompe la hidratación contra el snapshot prerenderizado (el chunk no esta
// cargado al hidratar -> fallback -> mismatch -> React #418). Son livianas
// (reusan Footer/Seo/useProducts ya en el bundle), asi que el costo es minimo.
import Menu from './pages/Menu';
import Producto from './pages/Producto';
import NoEncontrado from './pages/NoEncontrado';
import Ubicaciones from './pages/Ubicaciones';
import Contacto from './pages/Contacto';
import Nosotros from './pages/Nosotros';
import Privacidad from './pages/Privacidad';
import Terminos from './pages/Terminos';
// /udla (canal campus "Galletas de Sara") es prerenderizada y NO-lazy, igual que
// /menu: sus OG quedan horneados en el HTML para el preview de WhatsApp y el
// arbol que hidrata no lleva ningun boundary de <Suspense> (evita React #418).
import GalletasSara from './pages/udla/GalletasSara';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import PageTracking from './components/PageTracking';

// El panel de cocina (/panel-cocina) se carga bajo demanda (code splitting): no
// viaja en el bundle de la home pública y NO se prerenderiza (es privado), asi
// que su <Suspense> lazy es seguro (no hay HTML prerenderizado que hidratar).
const Admin = lazy(() => import('./pages/Admin'));

// El panel de Sara (/udla/admin) es privado (token) y NO se prerenderiza: se
// carga bajo demanda con <Suspense>, igual que /panel-cocina.
const AdminSara = lazy(() => import('./pages/udla/AdminSara'));

function App() {
  // El Toaster (sonner) se monta SOLO en el cliente, tras hidratar, y NO en el
  // prerender (Chrome headless). Así su <section> no aparece en el HTML
  // prerenderizado ni en la primera pintura del cliente -> hidratación limpia.
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.webdriver) return;
    setMounted(true);
  }, []);

  const routeFallback = <div style={{ padding: 40, textAlign: 'center', color: '#4a3428' }}>Cargando…</div>;

  return (
    <div className="App">
      {mounted && <Toaster position="top-center" richColors />}
      <AuthProvider>
        <BrowserRouter>
          <PageTracking />
          {/* Las rutas prerenderizadas (/, /menu, /ubicaciones, /contacto) NO
              llevan <Suspense>: sus componentes son no-lazy, asi el arbol que
              hidrata hydrateRoot no tiene ningun boundary (cuyos marcadores SSR
              el prerender-snapshot no conserva -> React #418). Solo /panel-cocina
              (lazy, no prerenderizado, privado) va dentro de <Suspense>. */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            {/* Sin lazy: se prerenderiza, y un <Suspense> en el arbol rompe la
                hidratacion contra el snapshot (React #418). */}
            <Route path="/producto/:slug" element={<Producto />} />
            <Route path="/ubicaciones" element={<Ubicaciones />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/udla" element={<GalletasSara />} />
            <Route path="/udla/admin" element={<Suspense fallback={routeFallback}><AdminSara /></Suspense>} />
            <Route path="/panel-cocina" element={<Suspense fallback={routeFallback}><Admin /></Suspense>} />
            {/* Respaldo: sin esto, una URL desconocida no casaba ninguna ruta y
                el visitante veia una pagina EN BLANCO. */}
            <Route path="*" element={<NoEncontrado />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
